import React, { useContext } from "react";
import {
  BrowserRouter,
  Routes,
  Route,
  Link
} from "react-router-dom";

import Home from '../Pages/Home'
export default function Index() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={< Home />} />
      </Routes>
    </BrowserRouter>
  )
}

